export const CORPORATE_MASTER_DATA_UPLOAD = 'CORPORATE_MASTER_DATA_UPLOAD'
export const CORPORATE_MASTER_DATA_UPLOAD_FAILURE = 'CORPORATE_MASTER_DATA_UPLOAD_FAILURE'
export const CORPORATE_MASTER_DATA_UPLOAD_SUCCESS = 'CORPORATE_MASTER_DATA_UPLOAD_SUCCESS'

export const corporateMasterDataUpload = (data) => {
    return {
        type: CORPORATE_MASTER_DATA_UPLOAD,
        data
    }
}

export const corporateMasterDataUploadFailure  = (data) => {
    return {
        type: CORPORATE_MASTER_DATA_UPLOAD_FAILURE,
        data
    }
}
export const corporateMasterDataUploadSuccess = (data) => {
    return {
        type: CORPORATE_MASTER_DATA_UPLOAD_SUCCESS,
        data
    }
}



export const CORPORATE_MASTER_TEMPLATE_REQUEST = 'CORPORATE_MASTER_TEMPLATE_REQUEST';
export const CORPORATE_MASTER_TEMPLATE_SUCCESS = 'CORPORATE_MASTER_TEMPLATE_SUCCESS';
export const CORPORATE_MASTER_TEMPLATE_FAILURE = 'CORPORATE_MASTER_TEMPLATE_FAILURE';

export const corporateMasterTemplateRequest = () => {
    return {
        type: CORPORATE_MASTER_TEMPLATE_REQUEST,
    }
}

export const corporateMasterTemplateSuccess = (data) => {
    return {
        type: CORPORATE_MASTER_TEMPLATE_SUCCESS,
        data
    }
}

export const corporateMasterTemplateFailure = (data) => {
    return {
        type: CORPORATE_MASTER_TEMPLATE_FAILURE,
        data
    }
}


export const CORPORATE_MASTER_DATA_EXCEL_SUCCESS = 'CORPORATE_MASTER_DATA_EXCEL_SUCCESS';
export const CORPORATE_MASTER_DATA_EXCEL_FAILURE = 'CORPORATE_MASTER_DATA_EXCEL_FAILURE';
export const CORPORATE_MASTER_DATA_EXCEL_REQUEST = 'CORPORATE_MASTER_DATA_EXCEL_REQUEST';

export const corporateMasterDataExcelRequest = () => {
    return {
        type: CORPORATE_MASTER_DATA_EXCEL_REQUEST,
    }
}

export const corporateMasterDataExcelSuccess = (data) => {
    return {
        type: CORPORATE_MASTER_DATA_EXCEL_SUCCESS,
        data
    }
}

export const corporateMasterDataExcelFailure = (data) => {
    return {
        type: CORPORATE_MASTER_DATA_EXCEL_FAILURE,
        data
    }
}


export const CORPORATE_MASTER_LIST_REQUEST = 'CORPORATE_MASTER_LIST_REQUEST';
export const CORPORATE_MASTER_LIST_SUCCESS = 'CORPORATE_MASTER_LIST_SUCCESS';
export const CORPORATE_MASTER_LIST_FAILURE = 'CORPORATE_MASTER_LIST_FAILURE';

export const corporateMasterListRequest = (data) => ({
    type: CORPORATE_MASTER_LIST_REQUEST,
    data
});

export const corporateMasterListSuccess = (data) => ({
    type: CORPORATE_MASTER_LIST_SUCCESS,
    data
});

export const corporateMasterListFailure = (data) => ({
    type: CORPORATE_MASTER_LIST_FAILURE,
    data
});

export const CORPORATE_MASTER_GET_CORPORATES_REQUEST = 'CORPORATE_MASTER_GET_CORPORATES_REQUEST';
export const CORPORATE_MASTER_GET_CORPORATES_SUCCESS = 'CORPORATE_MASTER_GET_CORPORATES_SUCCESS';
export const CORPORATE_MASTER_GET_CORPORATES_FAILURE = 'CORPORATE_MASTER_GET_CORPORATES_FAILURE';

export const corporateMasterGetCorporatesRequest = () => ({
    type: CORPORATE_MASTER_GET_CORPORATES_REQUEST,
});

export const corporateMasterGetCorporatesSuccess = (data) => ({
    type: CORPORATE_MASTER_GET_CORPORATES_SUCCESS,
    data,
});

export const corporateMasterGetCorporatesFailure = (data) => ({
    type: CORPORATE_MASTER_GET_CORPORATES_FAILURE,
    data,
});
